import { GetNextReshuffleFeeResponse } from '../../types/character';

export const getNextReshuffleFeeModel = (response: GetNextReshuffleFeeResponse): GetNextReshuffleFeeResponse => response;
